import React from 'react';
import { Html5Qrcode } from "html5-qrcode";

const dataURLtoFile = (dataUrl, filename) => {
  const [header, data] = dataUrl.split(',');
  const mime = header.match(/:(.*?);/)[1];
  const binary = atob(data);
  const arr = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) arr[i] = binary.charCodeAt(i);
  return new File([arr], filename, { type: mime });
};

export class QrImage extends React.Component {

  render() {
    return <div id={this.props.id} style={{ width: "1920px", position: "fixed", objectFit: 'fill', height: 'auto' }} />;
  }

  async componentDidMount() {
    this.qr()
  }

  qr = async () => {
    try {
      const file = dataURLtoFile(this.props.image, this.props.id);
      const qr = new Html5Qrcode(this.props.id);
      qr.scanFileV2(file, false)
        .then((result) => this.props.callback(result.decodedText, result.result))
        .catch((err) => console.log(`Qr error: ${err}`));
    } catch (err) {
      return err;
    }
  }
}